// ... (other imports and code)

import { useQuery, useMutation } from '@apollo/client'
import { toast } from 'react-toastify'
import { ApproveAgreement } from '../../../graphql/mutation'
import { GET_FRANCHISE } from '../../../graphql/query'
import { useState } from 'react'
import Modal from 'react-modal'
import ApproveAgreementModal from './ApproveAgreementModal'

interface Props {
  franchiseId: any
}

const FranchiseAgreementDetails: React.FC<Props> = ({ franchiseId }) => {
  const [isApproveModalOpen, setIsApproveModalOpen] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>(false)

  const customModalStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-30%, -60%)'
    }
  }

  const openApproveModal = () => {
    setIsApproveModalOpen(true)
  }

  const afterOpenApproveModal = () => {
    // Additional setup after modal has opened (if needed)
  }

  const closeApproveModal = () => {
    setIsApproveModalOpen(false)
  }

  const { data, loading, error } = useQuery(GET_FRANCHISE, {
    variables: {
      input: {
        franchiseId: franchiseId,
        offset: 0,
        limit: 10
      }
    },
    context: {
      headers: {
        'access-control-allow-methods': 'Agreement-Details'
      }
    }
  })

  const franchiseAgreement = data?.getFranchise?.franchiseAgreements[0]
  const isApproved = franchiseAgreement?.approved || false

  if (loading) {
    return <p>Loading...</p>
  }

  if (error) {
    return <p>Error: {error.message}</p>
  }

  return (
    <div>
      <div className='card mb-5 mb-xl-10' id='kt_profile_details_view'>
        <div className='card-header cursor-pointer'>
          <div className='card-title m-0'>
            <h3 className='fw-bold m-0'>Franchise Agreement Details</h3>
          </div>
        </div>

        <div className='card-body p-9'>
          <div className='border p-4'>
            <div
              className='fw-bold fs-6 text-gray-800'
              dangerouslySetInnerHTML={{
                __html: franchiseAgreement?.content || ''
              }}
            />
          </div>

          <div className='d-flex justify-content-end mt-4'>
            {isApproved ? (
              <button className='btn btn-secondary' disabled>
                Approved
              </button>
            ) : (
              <div>
                <button className='btn btn-success' onClick={openApproveModal}>
                  Approve
                </button>
                {/* Approval Confirmation Modal */}
                <Modal
                  isOpen={isApproveModalOpen}
                  onAfterOpen={afterOpenApproveModal}
                  onRequestClose={closeApproveModal}
                  style={customModalStyles}
                  contentLabel='Approve Confirmation'
                >
                  <ApproveAgreementModal
                    closeApproveModal={closeApproveModal}
                    franchiseId={franchiseId}
                  />
                </Modal>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default FranchiseAgreementDetails
